


























































import Modal from "./Modal.vue";

export default {
    name: "EditionModal",
    components: { Modal },
    props: {
        showModal: Boolean,
        title: String,
        saveFunction: Function,
        forceEditing: Boolean,
        editable: Boolean,
        blockSaving: Boolean,
    },
    data() {
        return {
            editing: false,
            saving: false,
        };
    },
    methods: {
        closeModal(data): void {
            this.editing = false;
            this.$emit("close-modal", data);
        },
        saveData: function (): void {
            var self = this;
            if (self.saving) {
                return;
            }
            let promise = this.saveFunction();
            if (promise) {
                self.saving = true;
                promise.then(function (res) {
                    self.saving = false;
                    self.toggleEdit(res);
                });
            }
        },
        toggleEdit: function (data): void {
            this.editing = !this.editing;
            if (!this.editing) {
                this.closeModal(data);
            }
        },
    },
    watch: {
        showModal: {
            immediate: true,
            handler: function (newVal) {
                if (this.forceEditing) {
                    this.editing = true;
                }
            },
        },
        forceEditing: {
            immediate: true,
            handler: function (newVal) {
                if (newVal) {
                    this.editing = true;
                }
            },
        },
        blockSaving: {
            immediate: true,
            handler: function (newVal) {
                this.saving = newVal;
            },
        },
    },
};
